import React, { useCallback, useRef, useState } from 'react';

interface Point {
    x: number;
    y: number;
}

const POINT_ORIGIN = { x: 0, y: 0 };

const usePan = () => {
    const previousPoint = useRef(POINT_ORIGIN);
    const [pos, setPosition] = useState<Point>(POINT_ORIGIN);

    const pan = useCallback(({ pageX, pageY }: MouseEvent) => {
        setPosition(previousPos => ({
            x: previousPos.x + previousPoint.current.x - pageX,
            y: previousPos.y + previousPoint.current.y - pageY,
        }));
        previousPoint.current = { x: pageX, y: pageY };
    }, []) as EventListener;

    const complete = useCallback(() => {
        document.querySelector('#root')?.removeEventListener('mousemove', pan);
        document.removeEventListener('mouseup', complete);
    }, [pan]);

    const start = useCallback((e: React.MouseEvent) => {
        document.querySelector('#root')?.addEventListener('mousemove', pan);
        document.addEventListener('mouseup', complete);
        previousPoint.current = { x: e.pageX, y: e.pageY };
    }, [pan, complete]);

    const reset = () => setPosition(POINT_ORIGIN);

    return [pos, start, reset] as [Point, (e: React.MouseEvent) => void, () => void];
};

export default usePan;
